var AppEnvironment = /* @__PURE__ */ ((AppEnvironment2) => {
  AppEnvironment2["DEV"] = "dev";
  AppEnvironment2["ALPHA"] = "alpha";
  AppEnvironment2["BETA"] = "beta";
  AppEnvironment2["PRODUCTION"] = "prd";
  return AppEnvironment2;
})(AppEnvironment || {});

export { AppEnvironment };
//# sourceMappingURL=utils.js.map
